import axios from "axios";
import { API } from "../Common";

export default {
    getRestaurant: function (id) {
        id = id || localStorage.getItem("partner_id");
        return new Promise((resolve, reject) => {
            axios
                .get(API + `restaurants/${id}`)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error && error.response ? error.response.data : error);
                });
        });
    }
};



// WEBPACK FOOTER //
// ./src/services/api/Restaurant.js